module.exports = __webpack_public_path__ + "components/weather-icon/static/nightheavysnow-51a6e6c4d7b50f66c8409ab902243726.svg";